/**
 * Sidebar Dynamic Styling Utility
 * Handles responsive adjustments for content area when sidebar state changes
 */

export const getSidebarClasses = (collapsed, isPublicRoute) => {
  if (isPublicRoute) {
    return {
      navPageClasses: 'w-full h-screen m-0 p-0',
      sidebarClasses: 'hidden'
    };
  }

  return {
    navPageClasses: `
      transition-all duration-300 ease-in-out
      ${collapsed ? 'ml-16 w-[calc(100vw-4rem)]' : 'ml-64 w-[calc(100vw-16rem)]'}
      h-[calc(100vh-3.5rem)] mt-14 overflow-y-auto
    `,
    sidebarClasses: `
      transition-all duration-300 ease-in-out
      ${collapsed ? 'w-16' : 'w-64'}
    `
  };
};

export const getResponsiveNavPageStyle = (collapsed, isPublicRoute) => {
  if (isPublicRoute) {
    return {
      width: '100vw',
      marginLeft: '0',
      height: '100vh'
    };
  }

  return {
    width: collapsed ? 'calc(100vw - 4rem)' : 'calc(100vw - 16rem)',
    marginLeft: collapsed ? '4rem' : '16rem',
    height: 'calc(100vh - 3.5rem)',
    marginTop: '3.5rem',
    transition: 'margin-left 0.3s ease, width 0.3s ease'
  };
};